import * as ambassadorWixStoresCatalogV3Customization from './stores-catalog-v3-customization-customizations-v-3.http.js';
import * as ambassadorWixStoresCatalogV3CustomizationTypes from './stores-catalog-v3-customization-customizations-v-3.types.js';
import * as ambassadorWixStoresCatalogV3CustomizationUniversalTypes from './stores-catalog-v3-customization-customizations-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCustomization(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.CreateCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.CreateCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.CreateCustomizationResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.CreateCustomizationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.createCustomization(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCustomization(): __PublicMethodMetaInfo<
  'GET',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.GetCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.GetCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.GetCustomizationResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.GetCustomizationResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.getCustomization(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/customizations/{customizationId}',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCustomization(): __PublicMethodMetaInfo<
  'PATCH',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.UpdateCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.UpdateCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.UpdateCustomizationResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.UpdateCustomizationResponse
> {
  const payload = { customization: { id: ':customizationId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.updateCustomization(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/customizations/{customization.id}',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCustomization(): __PublicMethodMetaInfo<
  'DELETE',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.DeleteCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.DeleteCustomizationRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.DeleteCustomizationResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.DeleteCustomizationResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.deleteCustomization(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/customizations/{customizationId}',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCustomizations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.QueryCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.QueryCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.QueryCustomizationsResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.QueryCustomizationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.queryCustomizations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/customizations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateCustomizations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkCreateCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkCreateCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkCreateCustomizationsResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkCreateCustomizationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.bulkCreateCustomizations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/customizations/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.AddCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.AddCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.AddCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.AddCustomizationChoicesResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.addCustomizationChoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations/{customizationId}/add-choices',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.SetCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.SetCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.SetCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.SetCustomizationChoicesResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.setCustomizationChoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations/{customizationId}/set-choices',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.RemoveCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.RemoveCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.RemoveCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.RemoveCustomizationChoicesResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.removeCustomizationChoices(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations/{customizationId}/remove-choices',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.UpdateCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.UpdateCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.UpdateCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.UpdateCustomizationChoicesResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.updateCustomizationChoices(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations/{customizationId}/update-choices',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reorderCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  { customizationId: string },
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.ReorderCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.ReorderCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.ReorderCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.ReorderCustomizationChoicesResponse
> {
  const payload = { customizationId: ':customizationId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.reorderCustomizationChoices(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/customizations/{customizationId}/reorder-choices',
    pathParams: { customizationId: 'customizationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAddCustomizationChoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkAddCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkAddCustomizationChoicesRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkAddCustomizationChoicesResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkAddCustomizationChoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.bulkAddCustomizationChoices(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/customizations/add-choices',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateCustomizations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkUpdateCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkUpdateCustomizationsRequest,
  ambassadorWixStoresCatalogV3CustomizationUniversalTypes.BulkUpdateCustomizationsResponse,
  ambassadorWixStoresCatalogV3CustomizationTypes.BulkUpdateCustomizationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Customization.bulkUpdateCustomizations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/customizations/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Customization as CustomizationOriginal,
  CustomizationCustomizationSettingsOneOf as CustomizationCustomizationSettingsOneOfOriginal,
  CustomizationType as CustomizationTypeOriginal,
  CustomizationTypeWithLiterals as CustomizationTypeWithLiteralsOriginal,
  CustomizationRenderType as CustomizationRenderTypeOriginal,
  CustomizationRenderTypeWithLiterals as CustomizationRenderTypeWithLiteralsOriginal,
  FreeTextSettings as FreeTextSettingsOriginal,
  ChoicesSettings as ChoicesSettingsOriginal,
  Choice as ChoiceOriginal,
  ChoiceValueOneOf as ChoiceValueOneOfOriginal,
  ChoiceType as ChoiceTypeOriginal,
  ChoiceTypeWithLiterals as ChoiceTypeWithLiteralsOriginal,
  MultipleColors as MultipleColorsOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  CommonImage as CommonImageOriginal,
  ChoiceSortStrategy as ChoiceSortStrategyOriginal,
  ChoiceSortStrategyWithLiterals as ChoiceSortStrategyWithLiteralsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateCustomizationRequest as CreateCustomizationRequestOriginal,
  CreateCustomizationResponse as CreateCustomizationResponseOriginal,
  GetCustomizationRequest as GetCustomizationRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetCustomizationResponse as GetCustomizationResponseOriginal,
  UpdateCustomizationRequest as UpdateCustomizationRequestOriginal,
  UpdateCustomizationResponse as UpdateCustomizationResponseOriginal,
  DeleteCustomizationRequest as DeleteCustomizationRequestOriginal,
  DeleteCustomizationResponse as DeleteCustomizationResponseOriginal,
  QueryCustomizationsRequest as QueryCustomizationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryCustomizationsResponse as QueryCustomizationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateCustomizationsRequest as BulkCreateCustomizationsRequestOriginal,
  BulkCreateCustomizationsResponse as BulkCreateCustomizationsResponseOriginal,
  BulkCustomizationResult as BulkCustomizationResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  CustomizationIdsWrapper as CustomizationIdsWrapperOriginal,
  BulkCreateCustomizationsForMigrationRequest as BulkCreateCustomizationsForMigrationRequestOriginal,
  BulkCreateCustomizationsForMigrationResponse as BulkCreateCustomizationsForMigrationResponseOriginal,
  AddCustomizationChoicesRequest as AddCustomizationChoicesRequestOriginal,
  AddCustomizationChoicesResponse as AddCustomizationChoicesResponseOriginal,
  SetCustomizationChoicesRequest as SetCustomizationChoicesRequestOriginal,
  SetCustomizationChoicesResponse as SetCustomizationChoicesResponseOriginal,
  RemoveCustomizationChoicesRequest as RemoveCustomizationChoicesRequestOriginal,
  RemoveCustomizationChoicesResponse as RemoveCustomizationChoicesResponseOriginal,
  UpdateCustomizationChoicesRequest as UpdateCustomizationChoicesRequestOriginal,
  MaskedChoice as MaskedChoiceOriginal,
  UpdateCustomizationChoicesResponse as UpdateCustomizationChoicesResponseOriginal,
  ReorderCustomizationChoicesRequest as ReorderCustomizationChoicesRequestOriginal,
  ReorderCustomizationChoicesResponse as ReorderCustomizationChoicesResponseOriginal,
  ChoiceIdsMismatchData as ChoiceIdsMismatchDataOriginal,
  BulkAddCustomizationChoicesRequest as BulkAddCustomizationChoicesRequestOriginal,
  CustomizationChoices as CustomizationChoicesOriginal,
  BulkAddCustomizationChoicesResponse as BulkAddCustomizationChoicesResponseOriginal,
  BulkUpdateCustomizationsRequest as BulkUpdateCustomizationsRequestOriginal,
  MaskedCustomization as MaskedCustomizationOriginal,
  BulkUpdateCustomizationsResponse as BulkUpdateCustomizationsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  RecloneSiteRequest as RecloneSiteRequestOriginal,
  RecloneSiteResponse as RecloneSiteResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateCustomizationApplicationErrors as CreateCustomizationApplicationErrorsOriginal,
  CreateCustomizationValidationErrors as CreateCustomizationValidationErrorsOriginal,
  DeleteCustomizationValidationErrors as DeleteCustomizationValidationErrorsOriginal,
  BulkCreateCustomizationsApplicationErrors as BulkCreateCustomizationsApplicationErrorsOriginal,
  BulkCreateCustomizationsValidationErrors as BulkCreateCustomizationsValidationErrorsOriginal,
  AddCustomizationChoicesApplicationErrors as AddCustomizationChoicesApplicationErrorsOriginal,
  AddCustomizationChoicesValidationErrors as AddCustomizationChoicesValidationErrorsOriginal,
  SetCustomizationChoicesApplicationErrors as SetCustomizationChoicesApplicationErrorsOriginal,
  SetCustomizationChoicesValidationErrors as SetCustomizationChoicesValidationErrorsOriginal,
  RemoveCustomizationChoicesApplicationErrors as RemoveCustomizationChoicesApplicationErrorsOriginal,
  RemoveCustomizationChoicesValidationErrors as RemoveCustomizationChoicesValidationErrorsOriginal,
  UpdateCustomizationChoicesApplicationErrors as UpdateCustomizationChoicesApplicationErrorsOriginal,
  UpdateCustomizationChoicesValidationErrors as UpdateCustomizationChoicesValidationErrorsOriginal,
  ReorderCustomizationChoicesApplicationErrors as ReorderCustomizationChoicesApplicationErrorsOriginal,
  BulkAddCustomizationChoicesApplicationErrors as BulkAddCustomizationChoicesApplicationErrorsOriginal,
  BulkAddCustomizationChoicesValidationErrors as BulkAddCustomizationChoicesValidationErrorsOriginal,
} from './stores-catalog-v3-customization-customizations-v-3.types.js';
